/* ====================================================================
   THE COIN BOX  ·  station arcade pricing oracle
   Some machines take a quarter. Some are free. Which is which moves on
   a 10m18s slot (618s) and is different for every machine — and if you
   camp one machine, that machine's own dial turns under you. There is a
   pattern. It is a golden-ratio rotation, and it is not findable by
   watching one cabinet.
   ==================================================================== */
(function(){
  if (window.STATION_COINBOX) return;
  var PHI = 1.6180339887498948, INV2 = 0.3819660112501051; /* 1/phi^2 */
  var SLOT = 618;                       /* seconds per rotation */
  var PRICE = 25;                       /* cents */
  var ORDER = ['beam','cut','catch','hatch','net','dock','stow','contact','recall','count','color','math','pattern','nback'];
  var WALLET='station.coinbox.v1';
  function frac(x){ return x - Math.floor(x); }
  function read(){ try { return JSON.parse(localStorage.getItem(WALLET)||'null') || {tokens:0, plays:{}}; } catch(e){ return {tokens:0, plays:{}}; } }
  function save(w){ try { localStorage.setItem(WALLET, JSON.stringify(w)); } catch(e){} }
  function slotNow(){ return Math.floor(Date.now()/1000/SLOT); }
  function idx(id){ var i = ORDER.indexOf(id); return i < 0 ? 7 : i; }
  /* the dial: irrational rotation per machine, per slot, plus the camp term */
  function dial(id, slot){
    var w = read(), camp = (w.plays && w.plays[id]) || 0;
    var seed = (slot + 1) * PHI + (idx(id) + 1) * PHI * PHI + camp * INV2;
    return frac(seed * PHI);
  }
  /* STORM LEGAL: until counsel clears paid play, every machine is free and the
     coin box never asks for a token. One theme checkbox governs the whole deck. */
  function paidCleared(){ return window.STATION_PAID === true; }
  function isFree(id, slot){
    if (!paidCleared()) return true;
    return dial(id, slot === undefined ? slotNow() : slot) < INV2;
  }
  function secsLeft(){ return SLOT - Math.floor(Date.now()/1000) % SLOT; }
  function clock(){ var s = secsLeft(); return String(Math.floor(s/60)).padStart(2,'0')+':'+String(s%60).padStart(2,'0'); }
  function tokens(){ return read().tokens|0; }
  function addTokens(n){ var w = read(); w.tokens = Math.max(0,(w.tokens|0) + n); save(w); bus(); return w.tokens; }
  function spend(id){
    var w = read();
    if ((w.tokens|0) <= 0) return false;
    w.tokens--; w.plays = w.plays || {}; w.plays[id] = (w.plays[id]||0) + 1; save(w); bus(); return true;
  }
  function played(id){ var w = read(); w.plays = w.plays || {}; w.plays[id] = (w.plays[id]||0)+1; save(w); }
  function bus(){ try { window.dispatchEvent(new CustomEvent('coinbox')); } catch(e){} }
  window.STATION_COINBOX = {
    PRICE: PRICE, SLOT: SLOT, ORDER: ORDER,
    isFree: isFree, slot: slotNow, secsLeft: secsLeft, clock: clock,
    tokens: tokens, addTokens: addTokens, spend: spend, played: played,
    paidCleared: paidCleared,
    label: function(id){ return isFree(id) ? 'FREE PLAY' : '25\u00A2 \u00B7 ONE PLAY'; },
    /* one place to point the buy button once the token product exists */
    buyUrl: (window.STATION_TOKEN_URL || '/products/arcade-tokens')
  };
  /* re-broadcast on every slot turn so chips and gates never go stale */
  setInterval(bus, 1000);
})();
